import { render, staticRenderFns } from "./ClinicSettingIcon.vue?vue&type=template&id=92437516&"
import script from "./ClinicSettingIcon.vue?vue&type=script&lang=js&"
export * from "./ClinicSettingIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports